import { ArrowRight, Shield, TrendingUp, Users, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const Home = () => {
  const features = [
    {
      icon: <Shield size={32} />,
      title: 'Secure & Regulated',
      description: 'SEBI registered and NSE/BSE approved brokers for complete safety',
    },
    {
      icon: <TrendingUp size={32} />,
      title: 'Zero Charges',
      description: 'Open your Demat account with ₹0 account opening fee',
    },
    {
      icon: <Users size={32} />,
      title: '2 Crore+ Investors',
      description: 'Join millions of satisfied investors trading daily',
    },
  ];

  const benefits = [
    'Instant account opening in under 10 minutes',
    'Trade in Equity, F&O, Commodities, Currency',
    'Zero brokerage on Equity Delivery',
    'Advanced trading platforms & mobile apps',
    'Free research & market insights',
    '24/7 customer support',
  ];

  return (
    <div>
      <section className="hero-section" style={{ backgroundColor: '#FAFAFA' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-block mb-6">
                <span
                  className="text-xs uppercase tracking-[0.2em] font-semibold px-4 py-2"
                  style={{ backgroundColor: '#FFF4E6', color: '#FF5722' }}
                >
                  Trusted by 2 Crore+ Investors
                </span>
              </div>
              <h1
                className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-bold mb-6"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A', lineHeight: '1.1' }}
                data-testid="hero-heading"
              >
                Start Your Investment Journey with India's #1 Trading Platform
              </h1>
              <p className="text-base leading-relaxed mb-8" style={{ color: '#475569' }}>
                Open your Demat account with Angel One in minutes. Zero account opening charges,
                advanced trading tools, and expert guidance to help you grow your wealth.
              </p>
              <div className="flex flex-wrap gap-4">
                <Link
                  to="/brokerage-plans"
                  data-testid="hero-cta-button"
                  className="btn-primary inline-flex items-center gap-2"
                  style={{
                    backgroundColor: '#FF5722',
                    color: 'white',
                    fontWeight: 600,
                    padding: '1rem 2rem',
                    textDecoration: 'none',
                  }}
                >
                  Open Free Demat Account
                  <ArrowRight size={20} />
                </Link>
                <Link
                  to="/broker-comparison"
                  data-testid="compare-brokers-button"
                  className="btn-secondary inline-flex items-center gap-2"
                  style={{
                    backgroundColor: 'transparent',
                    border: '2px solid #0A0F1A',
                    color: '#0A0F1A',
                    fontWeight: 600,
                    padding: '1rem 2rem',
                    textDecoration: 'none',
                  }}
                >
                  Compare Brokers
                </Link>
              </div>
            </div>
            <div>
              <img
                src="https://static.prod-images.emergentagent.com/jobs/8ca83d7a-7a97-4399-bcba-ba4b236121ce/images/890f9334d346fc9a2bb476b552b4eb4840f8f4314ad0f123260c271ae4ce1f26.png"
                alt="Modern professional trading on smartphone"
                data-testid="hero-image"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="text-center mb-16">
            <h2
              className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-semibold mb-4"
              style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
            >
              Why Choose Angel One?
            </h2>
            <p className="text-base" style={{ color: '#475569' }}>
              India's most trusted trading platform with industry-leading features
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {features.map((feature, idx) => (
              <div
                key={idx}
                data-testid={`feature-card-${idx}`}
                className="card-hover bg-[#FFFFFF] border border-[rgba(10,15,26,0.05)] p-8"
              >
                <div className="mb-4" style={{ color: '#FF5722' }}>
                  {feature.icon}
                </div>
                <h3
                  className="text-xl sm:text-2xl font-semibold mb-3"
                  style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
                >
                  {feature.title}
                </h3>
                <p className="text-base" style={{ color: '#475569' }}>
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32" style={{ backgroundColor: '#FAFAFA' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2
                className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-semibold mb-6"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                Everything You Need to Start Trading
              </h2>
              <div className="space-y-4">
                {benefits.map((benefit, idx) => (
                  <div key={idx} className="flex items-start gap-3" data-testid={`benefit-${idx}`}>
                    <CheckCircle size={20} style={{ color: '#10B981', flexShrink: 0, marginTop: '2px' }} />
                    <span className="text-base" style={{ color: '#475569' }}>
                      {benefit}
                    </span>
                  </div>
                ))}
              </div>
              <Link
                to="/brokerage-plans"
                data-testid="benefits-cta-button"
                className="btn-primary inline-flex items-center gap-2 mt-8"
                style={{
                  backgroundColor: '#FF5722',
                  color: 'white',
                  fontWeight: 600,
                  padding: '1rem 2rem',
                  textDecoration: 'none',
                }}
              >
                Get Started Now
                <ArrowRight size={20} />
              </Link>
            </div>
            <div>
              <img
                src="https://static.prod-images.emergentagent.com/jobs/8ca83d7a-7a97-4399-bcba-ba4b236121ce/images/3c4b17395ce6e06b49d603252f1ce312326920148d70dd204c20432e3a66bade.png"
                alt="Tech grid background"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32" style={{ backgroundColor: '#0A0F1A' }}>
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24 text-center">
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-semibold mb-6"
            style={{ fontFamily: 'Outfit', color: '#FFFFFF' }}
          >
            Ready to Start Your Investment Journey?
          </h2>
          <p className="text-base mb-8" style={{ color: '#94A3B8' }}>
            Join 2 Crore+ investors who trust Angel One for their trading needs
          </p>
          <Link
            to="/brokerage-plans"
            data-testid="final-cta-button"
            className="btn-primary inline-flex items-center gap-2"
            style={{
              backgroundColor: '#FF5722',
              color: 'white',
              fontWeight: 600,
              padding: '1rem 2rem',
              textDecoration: 'none',
            }}
          >
            Open Free Account in 10 Minutes
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;